import RoutesMap from "../../route_control/RouteControl"
import { Dashboard } from "../../pages/dashboard"

export const DashboardRouteImport = {
    RoutesMap,
    Dashboard
}